import styled from '../../styled';
export default styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: height 0.3s;

  & > *:first-child,
  & > .divider + *:not(.divider) {
    .with-left-border-block {
      margin-top: 0.5rem;
      padding-top: 0;
    }
  }
`;
//# sourceMappingURL=SubMenu.js.map